import { QueryHookOptions } from '@apollo/client';
import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import {
  AwardsListItemFragment,
  AwardsListQuery,
  AwardsListQueryVariables,
  OfferFilter,
  useAwardsListQuery,
} from '@occc/graphql';

type GetAwardsListArgs = {
  filter: OfferFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions<AwardsListQuery, AwardsListQueryVariables>;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

const transformDataToAwardsArray = (data: AwardsListQuery): AwardsListItemFragment[] => {
  const { edges } = data.offers;
  return edges.map((item) => item.node);
};

export const useGetAwardsList = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: GetAwardsListArgs) => {
  const response = usePaginatedQuery(
    useAwardsListQuery,
    'offers.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        filter,
      },
      ...baseOptions,
    },
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: response.data ? transformDataToAwardsArray(response.data) : response.data,
  };
};
